import WelcomeOrgSchedulePreview from '@/screens/WelcomeOrgSchedulePreview';

export default function PrivateWelcomeOrgSchedulePreviewRoute() {
  return <WelcomeOrgSchedulePreview />;
}
